import { PartialCustomerModelInRedux } from "../customer";

import { CustomerTeamAction } from "./actions";
import * as actions from "./actionTypes";
import { CustomerTeam } from "./model";

export function customerTeams(state: PartialCustomerModelInRedux["teams"] = [], action: CustomerTeamAction): PartialCustomerModelInRedux["teams"] {
    switch (action.type) {
        case actions.LOAD_CUSTOMER_TEAMS_SUCCESS:
            return action.payload.teams.map(c => ({ ...c, listUpdated: new Date() }));
        case actions.UPDATE_CUSTOMER_TEAM_SUCCESS:
            return state.map(c => customerTeam(c, action));
        case actions.CREATE_CUSTOMER_TEAM_SUCCESS:
            return [...state, { ...action.payload.team, listUpdated: new Date() }];
        default:
            return state;
    }
}

function customerTeam(state: CustomerTeam, action: CustomerTeamAction): CustomerTeam {
    switch (action.type) {
        case actions.UPDATE_CUSTOMER_TEAM_SUCCESS:
            if (action.payload.teamId === state.id) {
                return { ...action.payload.team, listUpdated: new Date() };
            }
            return state;
        default:
            return state;
    }
}
